module.exports = __webpack_public_path__ + "img/img-1.bdce93b3.jpg";